<template>
    <div class="io-data-table">
        <loading
            :active.sync="isBusy"
            loader="dots"
            blur="20px"
            :is-full-page="false"
            :z-index="1000"
        ></loading>

        <div v-if="checkable" class="data-table-actions">
            <IoButton
                v-if="totalItems > selected.length && allCheckableAction"
                outlined
                size="xs"
                @click="selectAll()"
            >
                {{ allCheckableActionLabel }}
            </IoButton>
            <IoButton
                v-if="selected.length && allCheckableAction"
                outlined
                size="xs"
                @click="clearSelection()"
            >
                Alle Abwählen
            </IoButton>
        </div>

        <div
            v-if="this.show"
            class="io-data-table__cont"
            :class="{ 'with-actions': hasHtmlActions && hasVisibleFields }"
        >
            <div ref="cont">
                <table ref="header" class="header">
                    <tr>
                        <template
                            v-for="(field) in visibleFields"
                        >
                            <template v-if="field.key !== 'html_actions' && field.key !== 'html_extra' && field.key !== 'actions'">
                                <!-- TODO: Column sorting -->
                                <th v-if="checkable && field.key === 'id'" :key="field.key">
                                    <IoInput
                                        v-if="checkablePage"
                                        type="checkbox"
                                        :name="0"
                                        class="io-checkbox"
                                        style="height: 100%"
                                        :input="{ value: selectAllInitialValue }"
                                        @update="changeSelected({ value: $event.value, name: 'all' })"
                                    />
                                </th>
                                <th
                                    v-if="(typeof field.description === 'undefined' || field.description === null || field.description === '') && !checkable && field.key === 'id'"
                                    v-html="field.label"
                                    :key="field.key"
                                ></th>
                                <th
                                    v-if="(typeof field.description === 'undefined' || field.description === null || field.description === '') && field.key !== 'id'"
                                    v-html="field.label"
                                    :key="field.key"
                                ></th>
                                <th
                                    v-if="!(typeof field.description === 'undefined' || field.description === null || field.description === '') && field.key !== 'id'" :title="field.description" v-html="(field.label + ' <i class=\'fas fa-question-circle\'></i>')"
                                    style="cursor: help;"
                                    :key="field.key"
                                ></th>
                            </template>
                        </template>
                    </tr>
                </table>
                <table :class="multiline" ref="table">
                    <tr v-for="(item, inx) in currentItems" :key="inx">
                        <template v-for="(field) in visibleFields">
                            <template v-if="field.key !== 'html_actions' && field.key !== 'actions'">
                                <template v-if="field.key === 'id'">
                                    <td
                                        v-if="checkable"
                                        :key="field.key"
                                    >
                                        <IoInput
                                            type="checkbox"
                                            :name="item.id"
                                            class="io-checkbox"
                                            :input="{ value: selected.find(selection => selection === item.id) }"
                                            @update="changeSelected({ value: $event.value, name: item.id})"
                                        />
                                    </td>
                                    <td
                                        v-else
                                        v-html="item[field.key]"
                                        :title="item[field.key]"
                                        :key="field.key"
                                    ></td>
                                </template>
                                <template v-if="field.key !== 'id'">
                                    <td
                                        v-if="field.key === 'imgPreview'"
                                        class="io-data-table__img-preview"
                                    >
                                        <div></div>
                                        <div
                                            class="io-data-table__img-preview"
                                            :style="{
                                                backgroundImage: `url(${item[field.key]})`,
                                            }"
                                        ></div>
                                    </td>
                                    <td
                                        v-else-if="IOH.recVal(field, 'wordalign', false)"
                                        :key="field.key"
                                    >
                                        <span
                                            :ref="'wa_' + field.key"
                                            class="d-inline-block text-end"
                                            v-html="item[field.key]"
                                            :title="item[field.key]"
                                        ></span>
                                    </td>
                                    <td
                                        v-else
                                        v-html="item[field.key]"
                                        :title="item[field.key]"
                                        :key="field.key"
                                    ></td>
                                </template>
                            </template>
                        </template>
                    </tr>
                </table>
                <p v-if="showEmptyMessage">
                    Keine Einträge vorhanden.
                </p>
            </div>
            <div class="io-data-table__actions" ref="actions" v-if="(hasHtmlActions && hasVisibleFields) || hasActions">
                <div class="action-element action-element--main">

                </div>
                <div class="action-element" v-for="(row, inx) in currentItems" :key="inx">
                    <io-options-button
                        v-if="hasActions"
                        :actions="row.actions"
                        @action="$emit('action', $event)"
                        @clear="$emit('clear', $event)"
                    >
                    </io-options-button>
                    <template v-if="row.html_actions !== undefined && row.html_actions !== null && row.html_actions !== ''">
                        <io-options-button
                            v-if="actionStyle === 'context'"
                            :content="row.html_actions"
                        ></io-options-button>
                        <div v-if="actionStyle !== 'context'" v-html="row.html_actions"></div>
                    </template>
                </div>
            </div>

            <div class="io-data-table__extra-html" v-if="hasHtmlExtra">
                <div class="io-data-table__actions" ref="actions" v-if="hasHtmlActions && hasVisibleFields">
                    <div class="action-element" v-for="(row, inx) in currentItems" :key="inx">
                        <template v-if="IOH.recVal(row, 'html_extra') !== null">
                            <div v-html="row.html_extra"></div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="io-data-table__pagination g-io-form" v-if="isAsync || pagination">
            <div>
                <select @input="savePerPage" v-model="perPage" class="me-3 io-input-sm">
                    <option value="10">10 Einträge anzeigen</option>
                    <option value="25">25 Einträge anzeigen</option>
                    <option value="50">50 Einträge anzeigen</option>
                </select>
                <span class="d-none d-lg-inline">
                    {{ currentNumItems }} von {{ totalItems }} Einträgen
                </span>
            </div>
            <div>
                <IoPagination
                    :currentPage="currentPage"
                    :length="pageCount"
                    v-on:change="change($event)"
                ></IoPagination>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import IoPagination from './IoPagination.vue';

export default {
  name: 'IoDataTable',

  components: {
    IoPagination,
    Loading,
  },

  props: {
    filter: {
      type: Object,
      default: () => ({}),
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Array,
      default: () => ([]),
    },
    checkable: {
      type: Boolean,
      default: false,
    },
    checkablePage: {
      type: Boolean,
      default: () => true,
    },
    allCheckableAction: {
      type: String,
      default: () => null,
    },
    allCheckableActionLabel: {
      type: String,
      default: () => 'Alle Auswählen',
    },
    fields: {
      required: true,
      type: [Object, Array],
    },
    endpoint: {
      required: false,
      type: String,
    },
    sid: {
      required: false,
      type: String,
      default: () => null,
    },
    search: {
      required: false,
      type: String,
    },
    items: {
      type: [Array, Object],
    },
    sticky: {
      type: Boolean,
      default: true,
    },
    actionStyle: {
      type: String,
      default: 'context',
      validator: (value) => ['context', 'buttons'].indexOf(value) !== -1,
    },
    multiline: {
      type: Boolean,
      default: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
      validator: (val) => [10, 25, 50].indexOf(val) !== -1,
    },
  },

  data() {
    return {
      selected: [],
      pageSelection: [],
      currentPage: 1,
      perPage: parseInt(this.tableListGetValue('perPage')) || this.itemsPerPage,
      isBusy: false,
      fullPageLoader: false,
      currentNumItems: 0,
      currentItems: [],
      totalItems: 0,
      hasItemsWithActions: false,
      visibleKeys: this.fields.filter((field) => field.show ?? true).map((field) => field.key).filter((key) => key !== 'html_actions'),
      show: true,
      showEmptyMessage: false,
    };
  },

  watch: {
    currentPage(val) {
      this.getItems(this.filter);
    },
    perPage(val) {
      this.currentPage = 1;
      this.getItems(this.filter);
    },
    currentItems(items) {
      this.pageSelection = [];
      const itemsWithActions = items.filter((item) => typeof item.html_actions === 'string' && item.html_actions.trim() !== '');
      this.hasItemsWithActions = itemsWithActions.length > 0;
    },
    filter: {
      deep: true,
      handler() {
        this.currentPage = 1;
        this.getItems(this.filter);
      },
    },
  },

  computed: {
    pageCount() { return Math.ceil(this.totalItems / this.perPage); },
    hasEndpoint() {
      return typeof this.endpoint !== 'undefined' && this.endpoint !== null && this.endpoint !== '';
    },
    hasItems() {
      return Array.isArray(this.items);
    },
    isAsync() {
      return this.hasEndpoint;
    },
    hasHtmlActions() {
      let has = false;
      this.fields.forEach((field) => {
        if (field.key === 'html_actions') {
          has = true;
        }
      });

      return has && this.hasItemsWithActions;
    },
    hasActions() {
      let has = false;
      this.fields.forEach((field) => {
        if (field.key === 'actions') {
          has = true;
        }
      });

      return has;
    },
    hasHtmlExtra() {
      let has = false;

      this.currentItems.forEach((item) => {
        has = has || this.IOH.recVal(item, 'html_extra') !== null;
      });

      return has;
    },
    hasVisibleFields() {
      return this.visibleKeys.length > 0;
    },
    visibleFields() {
      return this.fields.filter((field) => this.visibleKeys.indexOf(field.key) >= 0);
    },
    selectAllInitialValue() {
      const items = this.items || this.currentItems;
      this.pageSelection = this.selected.filter((selection) => items.map(
        (item) => item.id,
      ).includes(selection));

      return this.pageSelection.length === items.length;
    },
  },

  mounted() {
    // Init selected values
    this.selected = (this.selected || []).concat(this.checked || []);
    // this.selected.map(selection => selection.id === 0 ? selection.page : false)

    this.selected.includes(0)
      ? this.changeSelected({ value: true, name: 'all' })
      : this.emitOnCheck();

    this.getItems();
    window.addEventListener('resize', this.setHeaderSizes);
    window.addEventListener('resize', this.setHtmlActionPadding);
    window.addEventListener('resize', this.setHtmlActionHeights);
    window.addEventListener('resize', this.setWordAlignSizes);

    this.sticky ? this.stickyHeader() : '';

    if (this.filter) {
      GlobalEvents.listen(
        'update-data-table',
        (payload) => {
          this.$emit('update');
          if (this.pageCount === this.currentPage) {
            this.getItems(payload, true)
              .then((items) => {
                if (this.currentPage >= 1 && items.length <= 0) {
                  this.currentPage--;
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
          this.getItems(payload);
        },
      );
    }

    if (this.sid !== null) {
      GlobalEvents.listen(`table-toggle-fields.${this.sid}`, (keys) => {
        this.toggleFields(keys);
      });
    }
  },

  methods: {
    clearSelection() {
      this.pageSelection = [];
      this.selected = [];
      this.emitOnCheck();
    },
    selectAll() {
      const params = this.getFilter(this.filter);

      axios.get(this.allCheckableAction, { params })
        .then((res) => {
          this.selected = res.data;
          this.emitOnCheck();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    change(payload) {
      this.currentPage = payload;
      this.$emit('change', payload);
    },
    emitOnCheck() {
      this.$emit('onCheck', this.selected);
    },
    changeSelected({ name, value }) {
      const getIndexById = (itemId) => this.selected.indexOf(itemId);
      const items = this.items || this.currentItems;

      if (value && name === 'all') {
        items.forEach((item) => {
          if (getIndexById(item.id) === -1) {
            this.selected.push(item.id);
            this.pageSelection.push(item.id);
          }
        });

        this.emitOnCheck();
        return true;
      } if (!value && name === 'all') {
        items.forEach((item) => {
          const selectedItem = getIndexById(item.id);
          if (selectedItem !== -1) {
            this.selected.splice(selectedItem, 1);
            this.pageSelection.splice(selectedItem, 1);
          }
        });

        this.emitOnCheck();
        return false;
      }

      if (this.selected.find((selection) => selection === name)) {
        const index = getIndexById(name);
        this.selected.splice(index, 1);
        this.pageSelection.splice(index, 1);
      } else {
        this.selected.push(name);
        this.pageSelection.push(name);
      }

      this.emitOnCheck();
    },
    getItems(filter, simpleReturn = false) {
      if (!this.isAsync && this.hasItems && !simpleReturn) {
        const items = this.items.slice();

        this.currentItems = items;
        this.updateTotalItems(items.length || 0);
        this.showEmptyMessage = items.length === 0;

        this.$nextTick(this.setHeaderSizes);
        setTimeout(this.setHeaderSizes, 100);
        this.$nextTick(this.setHtmlActionPadding);
        setTimeout(this.setHtmlActionPadding, 100);
        this.$nextTick(this.setHtmlActionHeights);
        setTimeout(this.setHtmlActionHeights, 100);
        this.$nextTick(this.setWordAlignSizes);
        setTimeout(this.setWordAlignSizes, 100);

        return items;
      } if (!this.isAsync) {
        return {};
      }

      const params = this.getFilter(filter);

      this.isBusy = true;
      return new Promise((resolve, reject) => {
        axios.get(this.endpoint, {
          params,
        }).then(({ data }) => {
          const items = data.items || [];
          this.isBusy = false;
          if (simpleReturn) {
            resolve(items);
          } else {
            this.currentNumItems = items.length;

            this.currentItems = items;
            this.showEmptyMessage = items.length === 0;

            this.updateTotalItems(data.total || 0);

            this.$nextTick(this.setHeaderSizes);
            setTimeout(this.setHeaderSizes, 100);
            this.$nextTick(this.setHtmlActionPadding);
            setTimeout(this.setHtmlActionPadding, 100);
            this.$nextTick(this.setHtmlActionHeights);
            setTimeout(this.setHtmlActionHeights, 100);
            this.$nextTick(this.setWordAlignSizes);
            setTimeout(this.setWordAlignSizes, 100);

            resolve(items);
          }
        }).catch((response) => {
          this.isBusy = false;
          this.currentNumItems = 0;

          reject(response);
        });
      });
    },

    getFilter(filter) {
      return {
        ...{
          ...this.filter,
          ...filter,
          search: this.search
            ? this.search
            : filter
              ? filter.search
              : '',
        },
        page: this.currentPage,
        size: this.perPage,
      };
    },

    setHeaderSizes() {
      if (!this.$refs.header || !this.$refs.header.querySelectorAll('th') || !this.$refs.table.querySelector('tr')) {
        return false;
      }
      const headerCells = this.$refs.header.querySelectorAll('th');
      const contentCells = this.$refs.table.querySelector('tr').querySelectorAll('td');

      contentCells.forEach((cell, inx) => {
        cell.style.maxWidth = null;
        cell.style.minWidth = null;
        cell.style.width = '1%';
        cell.style.whiteSpace = 'nowrap';
        headerCells[inx].style.maxWidth = null;
        headerCells[inx].style.minWidth = null;
        headerCells[inx].style.width = '1%';
        headerCells[inx].style.whiteSpace = 'nowrap';

        const cellStyle = cell.currentStyle || window.getComputedStyle(cell);
        const cellWidth = cell.offsetWidth + parseFloat(cellStyle.paddingLeft) + parseFloat(cellStyle.paddingRight);
        const headerStyle = headerCells[inx].currentStyle || window.getComputedStyle(headerCells[inx]);
        const headerCellWidth = headerCells[inx].offsetWidth + parseFloat(headerStyle.paddingLeft) + parseFloat(headerStyle.paddingRight);

        if (cellWidth > headerCellWidth) {
          headerCells[inx].style.maxWidth = `${cellWidth}px`;
          headerCells[inx].style.minWidth = `${cellWidth}px`;
          headerCells[inx].style.width = `${cellWidth}px`;
          cell.style.maxWidth = `${cellWidth}px`;
          cell.style.minWidth = `${cellWidth}px`;
          cell.style.width = `${cellWidth}px`;
        } else {
          headerCells[inx].style.maxWidth = `${headerCellWidth}px`;
          headerCells[inx].style.minWidth = `${headerCellWidth}px`;
          headerCells[inx].style.width = `${headerCellWidth}px`;
          cell.style.maxWidth = `${headerCellWidth}px`;
          cell.style.minWidth = `${headerCellWidth}px`;
          cell.style.width = `${headerCellWidth}px`;
        }

        cell.style.whiteSpace = null;
        headerCells[inx].style.whiteSpace = null;
      });
    },

    stickyHeader() {
      const contentRect = this.$refs.cont.getBoundingClientRect();
      const headerHeight = document.querySelector('header').clientHeight;
      let top = contentRect.top - headerHeight;
      const headerBottom = this.$refs.header.getBoundingClientRect().bottom;
      const tableHeight = this.$refs.table.clientHeight;
      const tableRows = this.$refs.table.querySelectorAll('tr');
      let lastRowTop = 0;
      let lastRowHeight = tableHeight;
      if (tableRows.length) {
        lastRowHeight = tableRows[tableRows.length - 1].clientHeight;
        lastRowTop = tableRows[tableRows.length - 1].getBoundingClientRect().top;
      }
      const maxMargin = tableHeight - lastRowHeight;

      if (top > 0) {
        top = 0;
      }

      if (Math.abs(top) < maxMargin) {
        if ((top < 0 && headerBottom < lastRowTop)) {
          this.$refs.header.style.marginTop = `${Math.abs(top)}px`;
          this.$refs.header.style.marginBottom = `${top}px`;
        } else {
          this.$refs.header.style.marginTop = null;
          this.$refs.header.style.marginBottom = null;
        }
      } else {
        this.$refs.header.style.marginTop = `${maxMargin}px`;
        this.$refs.header.style.marginBottom = `${maxMargin * -1}px`;
      }

      window.requestAnimationFrame(this.stickyHeader);
    },

    setHtmlActionHeights() {
      if (this.hasHtmlActions || this.hasActions) {
        const headerHeight = this.$refs.header.clientHeight;

        this.$refs.actions.querySelectorAll('.action-element')[0].style.minHeight = `${headerHeight}px`;

        this.$refs.table.querySelectorAll('tr').forEach((row, inx) => {
          const height = row.clientHeight;

          const actionElement = this.$refs.actions.querySelectorAll('.action-element')[inx + 1];
          if (actionElement !== null) {
            actionElement.style.minHeight = `${height}px`;
          }
        });
      }
    },

    setWordAlignSizes() {
      this.fields.filter((field) => this.IOH.recVal(field, 'wordalign', false)).forEach((field) => {
        let minWidth = 0;
        const wordSpans = this.IOH.recVal(this.$refs, `wa_${field.key}`, []);
        wordSpans.forEach((span) => span.style.minWidth = null);
        wordSpans.forEach((span) => (span.offsetWidth > minWidth ? minWidth = span.offsetWidth : false));
        wordSpans.forEach((span) => span.style.minWidth = `${minWidth}px`);
      });
    },

    setHtmlActionPadding() {
      if (this.hasHtmlActions && this.$refs.cont) {
        this.$refs.cont.style.width = `calc(100% + 3.75rem - ${this.$refs.actions.clientWidth}px)`;
      }
    },

    updateTotalItems(count) {
      this.totalItems = count;
      document.querySelectorAll(`span[data-table-total="${this.sid}"]`).forEach((el) => {
        el.innerText = count;
      });
    },

    fieldIsVisible(key) {
      return this.visibleKeys.indexOf(key) >= 0;
    },

    showField(key, rerender = true) {
      if (!this.fieldIsVisible(key)) {
        this.visibleKeys.push(key);
      }

      if (rerender) this.rerender();
    },

    hideField(key, rerender = true) {
      if (this.fieldIsVisible(key)) {
        this.visibleKeys = this.visibleKeys.filter((field) => field !== key);
      }

      if (rerender) this.rerender();
    },

    toggleField(key, rerender = true) {
      if (this.fieldIsVisible(key)) {
        this.hideField(key, false);
      } else {
        this.showField(key, false);
      }

      if (rerender) this.rerender();
    },

    toggleFields(keys) {
      keys.forEach((key) => {
        this.toggleField(key, false);
      });

      this.rerender();
    },

    rerender() {
      this.$nextTick(this.setHeaderSizes);
      this.$nextTick(this.setHtmlActionHeights);
      this.$nextTick(this.setHtmlActionPadding);
      this.$nextTick(this.setWordAlignSizes);
    },

    getTableList() {
      let tableList = window.localStorage.getItem('io-dtb');

      if (tableList === null) {
        tableList = {};
      } else {
        tableList = JSON.parse(tableList);
      }

      return tableList;
    },

    tableListAddValue(key, value) {
      if (typeof this.sid === 'undefined' || this.sid === null || this.sid === '') {
        return false;
      }

      const tableList = this.getTableList();

      if (typeof tableList[this.sid] === 'undefined') {
        tableList[this.sid] = {};
      }

      tableList[this.sid][key] = value;

      window.localStorage.setItem('io-dtb', JSON.stringify(tableList));

      return true;
    },

    tableListGetValue(key) {
      const tableList = this.getTableList();

      if (typeof tableList[this.sid] === 'undefined' || typeof tableList[this.sid][key] === 'undefined') {
        return null;
      }

      return tableList[this.sid][key];
    },

    savePerPage(e) {
      this.tableListAddValue('perPage', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.io-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: var(--row-spacing);
    left: 0;
    right: 0;
}

.data-table-actions {
    padding: .5rem 0;
    display: flex;

    > *:not(:last-child){
        margin-right: .5rem;
    }
}

.io-data-table table:not(.multiline) td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.io-data-table__cont {
    display: flex;
    overflow: visible;

    &.with-actions {
        width: calc(100% + 14px);
    }

    .header {
        white-space: nowrap;
    }

    .io-data-table__actions {
        position: static;

        .action-element {
            padding: 5px 0px 5px 5px;

            @media screen and (min-width: 992px) {
                padding: 10px 0px 10px 1rem;
            }
        }
    }
}

.io-data-table__img-preview {
    position: relative;

    > div {
        &:first-child {
            min-width: 50px;
        }

        &:last-child {
            background-position: left center;
            background-size: contain;
            position: absolute;
            top: 10px;
            left: 20px;
            width: calc(100% - 40px);
            height: calc(100% - 20px);
            background-repeat: no-repeat;
        }
    }
}
</style>
